export type ParentMaterialLink = {
  title: string;
  url: string;
};

export const PARENTS_MATERIAL_LINKS: ParentMaterialLink[] = [
  {
    title: "料金プランの選択について",
    url: "https://drive.google.com/file/d/1zwr6w01_tqDXBqnNkI3keWze8dQJ8Vol/view?usp=drive_link",
  },
  {
    title: "トライアル利用開始のご案内",
    url: "https://docs.google.com/document/d/15Id7ghg3MYop1HNbn2J4ZBvXZTpcODHL/edit?usp=drive_link&ouid=112097286272895851742&rtpof=true&sd=true",
  },
  {
    title: "サービス内容のご案内チラシ",
    url: "https://drive.google.com/file/d/13Si7Fd4I4hDoS6oL2ZjSSCCRa-4F5hKx/view?usp=drive_link",
  },
  {
    title: "新規登録の手順について",
    url: "https://drive.google.com/file/d/1-SO3EjK37O16jcg9QObjRPvOd22MbENP/view?usp=drive_link",
  },
  {
    title: "導入同意書",
    url: "https://docs.google.com/document/d/1l9K0Pf2ZxMF963NjAMYOC3g8Q7kmbytJ/edit?usp=drive_link&ouid=112097286272895851742&rtpof=true&sd=true",
  },
];

export const PARENTS_MATERIAL_LINK_MAP = PARENTS_MATERIAL_LINKS.reduce<
  Record<string, string>
>((links, material) => {
  links[material.title] = material.url;
  return links;
}, {});
